export default __webpack_public_path__ + "1146c4731d7b3acaf67d57edcb92cf9b.png";